(() => {
  if (window.melalightUgcVolumeControls) return;
  window.melalightUgcVolumeControls = true;

  const updateButton = (video) => {
    const button = video.closest('.ugc-media__item')?.querySelector('[data-ugc-volume]');
    if (!button) return;

    const hasSound = !video.muted;
    button.setAttribute('aria-pressed', String(hasSound));
    button.setAttribute('aria-label', hasSound ? 'Mute video' : 'Unmute video');
  };

  const muteOtherVideos = (activeVideo) => {
    document.querySelectorAll('.ugc-media video').forEach((video) => {
      if (video === activeVideo || video.muted) return;
      video.muted = true;
      updateButton(video);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ugc-volume]');
    if (!button) return;

    const video = button.closest('.ugc-media__item')?.querySelector('video');
    if (!video) return;

    const shouldUnmute = video.muted;
    if (shouldUnmute) muteOtherVideos(video);
    video.muted = !shouldUnmute;
    updateButton(video);
  });

  document.addEventListener('volumechange', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.closest('.ugc-media')) return;

    if (!video.muted) muteOtherVideos(video);
    updateButton(video);
  }, true);
})();
